import styled from 'styled-components';
import { darken } from 'polished';

export const TabWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  .tabLine {
    width: calc(100% + 3rem);
    border-top: 1px solid rgb(185 188 192);
    align-self: center;
    justify-self: center;
  }
`;

export const TabContainer = styled.div`
  display: flex;
  margin-bottom: -1px;
  margin-right: 1.5rem;
  margin-top: 1rem;
  width: 100%;
  transition: all 0.5 linear;
  position: relative;
`;

export const Tab = styled.div`
  display: flex;
  min-width: 1.5rem;
  width: 100%;
  background-color: ${(props) => (props.isSelect ? '#fff' : '#e9ecef')};
  max-width: 12rem;
  height: 1.9rem;
  font-size: 0.875rem;
  transition: background-color 0.1s ease-in-out, width 0.25s ease-in-out;
  border: 1px solid rgb(185 188 192);
  border-bottom: ${(props) =>
    props.isSelect ? '1px solid white' : '1px solid rgb(185 188 192)'};

  margin-bottom: ${(props) => (props.isSelect ? '-1px' : '0px')};

  border-radius: ${(props) =>
    props.isSelect ? '0.1rem 0.1rem 0 0' : '0.25rem 0.25rem 0 0'};

  align-items: center;

  &:hover {
    background-color: ${(props) => (props.isSelect ? '' : '#ced1d7')};
  }

  &:first-child {
    border-radius: ${(props) =>
      props.isSelect ? '0.1rem 0.1rem 0 0' : '0.25rem 0.25rem 0 0'};
  }

  &:last-child {
    border-radius: 0rem 0.25rem 0.25rem 0rem;

    border-radius: ${(props) =>
      props.isSelect ? '0.1rem 0.1rem 0 0' : '0rem 0.25rem 0.25rem 0rem'};
  }

  span:first-child {
    text-align: left;
    margin: auto 0;
    margin-left: 0.5rem;
    width: 100%;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: default;
  }

  span:last-child {
    font-size: 1.2rem;
    cursor: pointer;
    margin-right: 1rem;

    &:hover {
      color: ${darken(0.2, '#74637f')};
    }
  }
`;
